
export default {
    name: 'YnSelect2v',
    props: {
        value: {
            type: String,
            default: ''
        },

        show_title: {
            type: String,
            default: ''
        },
        count: {
            type: Number,
            default: 3
        },
        multiple: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            popout_show: false,
            show_children: false,

            // 显示多选
            show_multiple: this.multiple,

            currentValue: this.value,

            check_title: '',

            popout_title: this.show_title,
            popout_type: this.type,

            popout_data: [],
            children_data: [],

            // 多选 START
            single: []
            // 多选 END
        };
    },
    computed: {

    },
    watch: {

    },
    mounted() {
        this.get_data()
        this.splice_data()
        // console.log(this.currentValue);
    },
    methods: {
        // 数组赋值
        get_data() {

            this.$axios({
                // baseURL: 'http://139.224.206.148:30010',
                url: '/StandardDictionary?key=' + this.popout_type,
                method: 'GET',
            }).then(res => {
                if (res.code == 200) {
                    this.splice_data(res.data)
                }
            })
            
        },

        // 切割数组
        splice_data(arr) {
            let allData = []; //用来装处理完的数组
            let currData = []; //子数组用来存分割完的数据
            //循环需要处理的数组            
            if (!arr) return;

            let json2 = []
            let keyMap = {}
            for (let i = 0; i < arr.length; i++) {
                let json1Elem = arr[i]
                let first = arr[0];
                //key 1,2,3,4,5
                let elemKey = parseInt(parseInt(json1Elem.k)/parseInt(first.k)) + "";
                // console.log(`key:${elemKey}`)
                if (elemKey in keyMap) {
                    // [{"1":{}}]
                    json2[keyMap[elemKey]].children.push(json1Elem) 
                } else {
                    json2.push({
                        'k': json1Elem.k,
                        'v': json1Elem.v,
                        'children': [],
                    })
                    keyMap[elemKey] = json2.length - 1
                }
            }
            
           
            // console.log(JSON.stringify(json2))
            

            json2.forEach(ele => {
                if (ele.hasOwnProperty("children")) {
                    for (let i = 0; i < ele.children.length; i++) {
                        //将chartArr[i]添加到子数组
                        currData.push(ele.children[i]);
                        if ((i != 0 && (i + 1) % this.count == 0) || i == ele.children.length - 1) {
                            allData.push(currData);
                            currData = [];
                        }
                    };
                    ele.children = allData;
                    allData = [];
                }
            });

            for (let i = 0; i < json2.length; i++) {
                currData.push(json2[i]);
                if ((i != 0 && (i + 1) % this.count == 0) || i == json2.length - 1) {
                    allData.push(currData);
                    currData = [];
                }
            }

            this.popout_data = allData;
            // console.log(JSON.stringify(this.popout_data));
        },

        // 发射选中的值
        emit_check(value, title) {
            this.$emit('emit_check', value, title);
            this.currentValue = value;

            // 选中后，关闭选项
            this.popout_show = false;
            this.show_children = false;
        },

        // 展开选项
        check_unfold() {
            this.popout_show = true;
        },
    },
};